export const monthLabels = [
  '2026-12',
  '2027-01',
  '2027-02',
  '2027-03',
  '2027-04',
  '2027-05',
  '2027-06',
  '2027-07',
  '2027-08',
  '2027-09',
  '2027-10',
  '2027-12',
];

export interface RevenueRow {
  key: string;
  timeRange: string;
  monthlyDemand: number;
  totalDemand: number;
  demandTrend?: 'up' | 'down';
  demandIncome: number;
  curtailedEnergy: number;
  curtailedRate: string;
  curtailmentTrend?: 'up' | 'down';
  curtailmentIncome?: string;
}

export const revenueRows: RevenueRow[] = [
  {
    key: 'baseline',
    timeRange: '基准(2025-01~2025-12)',
    monthlyDemand: 50,
    totalDemand: 50,
    demandIncome: 100.5,
    curtailedEnergy: 50,
    curtailedRate: '10%',
    curtailmentIncome: '--',
  },
  {
    key: '2029',
    timeRange: '2029年',
    monthlyDemand: 50,
    totalDemand: 2460.21,
    demandTrend: 'down',
    demandIncome: 100.5,
    curtailedEnergy: 2460.21,
    curtailedRate: '8%',
    curtailmentTrend: 'down',
    curtailmentIncome: '200.50万',
  },
  {
    key: '2028',
    timeRange: '2028年',
    monthlyDemand: 50,
    totalDemand: 50,
    demandTrend: 'up',
    demandIncome: 100.5,
    curtailedEnergy: 2460.21,
    curtailedRate: '6%',
    curtailmentIncome: '未满12个月，无法计算',
  },
  {
    key: '2027',
    timeRange: '2027年',
    monthlyDemand: 50,
    totalDemand: 50,
    demandTrend: 'up',
    demandIncome: 100.5,
    curtailedEnergy: 2460.21,
    curtailedRate: '6%',
    curtailmentIncome: '200.50万',
  },
  {
    key: '2026',
    timeRange: '2026年',
    monthlyDemand: 50,
    totalDemand: 50,
    demandTrend: 'up',
    demandIncome: 100.5,
    curtailedEnergy: 2460.21,
    curtailedRate: '8%',
    curtailmentTrend: 'down',
    curtailmentIncome: '200.50万',
  },
];
